import { render, staticRenderFns } from "./expertExtractionFrom.vue?vue&type=template&id=40b9b140&scoped=true"
import script from "./expertExtractionFrom.vue?vue&type=script&lang=js"
export * from "./expertExtractionFrom.vue?vue&type=script&lang=js"
import style0 from "./expertExtractionFrom.vue?vue&type=style&index=0&id=40b9b140&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9b140",
  null
  
)

export default component.exports